const UPDATE_MY_ALERTS_MODAL_SLOT = 'UPDATE_MY_ALERTS_MODAL_SLOT';

export default UPDATE_MY_ALERTS_MODAL_SLOT;
